<div
  class="gd-form-select-single-v2">

  <!-- Input data -->
  <mat-form-field
    *ngIf="!viewOnly; else viewOnlyTemplate"
    appearance="outline">

    <!-- Place holder -->
    <mat-label
      *ngIf="!neverFloatLabel">
      {{ placeholder | translate }}
    </mat-label>

    <!-- Left - Icon buttons -->
    <ng-container
      *ngIf="tooltipButton?.tooltip"
      matPrefix>
      <popper-content
        #popperContent>
        <div
          [innerHtml]="tooltipButton.tooltip | safeHtml">
        </div>
      </popper-content>
      <mat-icon
        tabindex="-1"
        [popper]="popperContent"
        popperTrigger="hover"
        popperApplyClass="gd-form-input-v2-tooltip"
        popperPreventOverflow="true"
        popperPositionFixed="true"
        popperAppendTo="body"
        (click)="$event.stopPropagation()">{{tooltipButton.icon}}</mat-icon>
    </ng-container>

    <!-- Select -->
    <mat-select
      [(ngModel)]="value"
      (closed)="onTouchItem()"
      [errorStateMatcher]="errMatcher"
      [disabled]="disabled"
      [required]="required"
      [placeholder]="neverFloatLabel ? (placeholder | translate) : undefined"
      panelClass="gd-form-select-single-v2-panel"
      (click)="vScrollToFirstSelectedOption()"
      (opened)="vScrollToFirstSelectedOption()">

      <!-- Selected value -->
      <mat-select-trigger
        *ngIf="value"
        [class.gd-form-select-single-v2-panel-with-icon]="allOptionsMap[value]?.icon">

        <!-- Icon -->
        <mat-icon
          *ngIf="allOptionsMap[value]?.icon">{{allOptionsMap[value].icon}}</mat-icon>

        <!-- Image -->
        <img
          *ngIf="allOptionsMap[value]?.iconUrl"
          [src]="allOptionsMap[value]?.iconUrl"/>

        <!-- Label -->
        {{allOptionsMap[value]?.label}}

      </mat-select-trigger>

      <!-- Search filter -->
      <mat-option>
        <ngx-mat-select-search
          [ngModel]="startSearch"
          [placeholderLabel]="'LNG_COMMON_LABEL_SEARCH' | translate"
          [noEntriesFoundLabel]="null"
          [clearSearchInput]="true"
          [disableScrollToActiveOnOptionsChanged]="true"
          [preventHomeEndKeyPropagation]="true"
          (ngModelChange)="filterOptions($event)">
        </ngx-mat-select-search>
      </mat-option>

      <!-- vscroll -->
      <cdk-virtual-scroll-viewport
        #cdkVirtualScrollViewport
        [itemSize]="40"
        [minBufferPx]="240"
        [maxBufferPx]="480"
        style="height: 20rem; overflow-x: hidden;">

        <!-- Empty option used to select nothing -->
        <mat-option
          *ngIf="clearable && !searchValue"
          [value]="null">
          {{ 'LNG_COMMON_LABEL_NONE' | translate }}
        </mat-option>

        <!-- Options -->
        <mat-option
          *cdkVirtualFor="let option of filteredOptions; templateCacheSize: 0"
          [value]="option.value"
          [disabled]="!allowDisabledToBeSelected && option.disabled">

          <!-- Icon & Label -->
          <div
            fxFlex
            [matTooltip]="optionTooltipKey ? option.data[optionTooltipKey] : undefined">

            <!-- Icon -->
            <mat-icon
              *ngIf="option.icon">{{option.icon}}</mat-icon>

            <!-- Image -->
            <img
              *ngIf="option.iconUrl"
              [src]="option.iconUrl"/>

            <!-- Label -->
            <span>
              {{option.label}}
            </span>

          </div>

          <!-- Infos -->
          <mat-icon
            *ngFor="let iconB of option.infos"
            fxGrow="0"
            [matTooltip]="iconB.label | translate">{{iconB.icon}}</mat-icon>

        </mat-option>

      </cdk-virtual-scroll-viewport>

      <!-- Selected option(s) hack to handle not visible in virtual scroll options -->
      <ng-container
        *ngIf="value">

        <!-- Option -->
        <mat-option
          style="height: 0; display: none;"
          [value]="value">

          <!-- Icon -->
          <mat-icon
            *ngIf="allOptionsMap[value]?.icon">{{allOptionsMap[value].icon}}</mat-icon>

          <!-- Image -->
          <img
            *ngIf="allOptionsMap[value]?.iconUrl"
            [src]="allOptionsMap[value]?.iconUrl"/>

          <!-- Label -->
          {{allOptionsMap[value]?.label}}
        </mat-option>

      </ng-container>

    </mat-select>

    <!-- Spinner -->
    <mat-progress-spinner
      *ngIf="loading || control?.pending"
      matSuffix
      diameter="16"
      mode="indeterminate"
      color="primary">
    </mat-progress-spinner>

    <!-- Right - Icon buttons -->
    <ng-container
      *ngFor="let iconB of suffixIconButtons"
      matSuffix>
      <span
        *ngIf="!iconB.visible || iconB.visible(this)"
        (click)="$event.stopPropagation()">
        <button
          [class.gd-form-select-single-v2-suffix-button-no-click]="!iconB.clickAction"
          tabindex="-1"
          type="button"
          mat-icon-button
          [matTooltip]="iconB.tooltip | translate"
          [disabled]="iconB.disabled && iconB.disabled(this)"
          (click)="iconB.clickAction ? iconB.clickAction(this) : undefined"><mat-icon>{{iconB.icon}}</mat-icon></button>
      </span>
    </ng-container>

    <!-- Errors -->
    <mat-error
      *ngIf="control?.invalid && control?.touched">
      {{ getErrorMessages() }}
    </mat-error>

  </mat-form-field>

  <!-- View only -->
  <ng-template
    #viewOnlyTemplate>
    <div
      fxLayout="row" fxLayoutGap="1.6rem"
      class="gd-form-select-single-v2-viewonly">
      <!-- Label -->
      <div
        *ngIf="placeholder"
        class="gd-form-select-single-v2-viewonly-label">
        {{ placeholder | translate }}:
      </div>

      <!-- Value -->
      <div
        class="gd-form-select-single-v2-viewonly-value">
        <!-- Has value -->
        <ng-container
          *ngIf="value; else noValue">
          <!-- Icon -->
          <mat-icon
            *ngIf="allOptionsMap[value]?.icon">{{allOptionsMap[value].icon}}</mat-icon>

          <!-- Image -->
          <img
            *ngIf="allOptionsMap[value]?.iconUrl"
            [src]="allOptionsMap[value]?.iconUrl"/>

          <!-- Label -->
          {{allOptionsMap[value]?.label | translate}}
        </ng-container>

        <!-- Doesn't have value -->
        <ng-template
          #noValue>
          {{noValueLabel}}
        </ng-template>
      </div>
    </div>
  </ng-template>
</div>
